let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBlMg")).then(() => parcelRequire('9H0ZF'));